import { IngredientItemFormType, SelectType, SymbolsType } from 'interfaces';
import { IngredientsItemFormInitialValues } from 'constants/formInitialValues';

export const TOKEN = 'access_token';
export const UNAUTHORIZED = 'Unauthorized';
export const TOKEN_INVALID = 'Token Invalid';
export const MAINTENANCE_ALERT = 'Maintenance is in progress';
export const BAD_REQUEST_EXCEPTION = 'Bad Request Exception';
export const SERVER_ERRORS = 'Validation Errors';

// Env
export const ENV = {
  ENVIRONMENT: process.env.REACT_APP_REACT_ENVIRONMENT || 'production',
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080',
  CYPRESS: process.env.CYPRESS_ENV || 'dev',
  STRIPE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '',
};

export const ADD_EMPTY: SelectType = {
  name: '--',
  value: '',
};

export const MACRO_NUTRIENT_TEXTS = {
  addedSugar: 'Added Sugar',
  carbohydrates: 'Carbohydrates',
  protein: 'Protein',
  calories: 'Calories',
  cholesterol: 'Cholesterol',
  dietaryFiber: 'Dietary Fiber',
  moisture: 'Moisture',
  monounsaturatedFat: 'Monounsaturated Fat',
  polyunsaturatedFat: 'Polyunsaturated Fat',
  saturatedFat: 'Saturated Fat',
  totalFat: 'Total Fat',
  totalSugars: 'Total Sugars',
  transFat: 'Trans Fat',
};

export const MICRO_NUTRIENT_TEXTS = {
  // vitamins
  vitaminA: 'Vitamin A',
  biotin: 'Biotin',
  pantothenicAcid: 'Pantothenic Acid',
  thiamin: 'Thiamin',
  riboflavin: 'Riboflavin',
  niacin: 'Niacin',
  vitaminB6: 'Vitamin B6',
  vitaminB12: 'Vitamin B12',
  vitaminC: 'Vitamin C',
  vitaminD: 'Vitamin D',
  vitaminE: 'Vitamin E',
  folate: 'Folate',
  vitaminK: 'Vitamin K',
  vitaminK2: 'Vitamin K2',
  folicAcid: 'Folic Acid',

  // minerals

  // macrominerals
  calcium: 'Calcium',
  phosphorus: 'Phosphorus',
  magnesium: 'Magnesium',
  sodium: 'Sodium',
  potassium: 'Potassium',
  chloride: 'Chloride',

  // microminerals
  iron: 'Iron',
  zinc: 'Zinc',
  iodine: 'Iodine',
  selenium: 'Selenium',
  copper: 'Copper',
  manganese: 'Manganese',
  chromium: 'Chromium',
  molybdenum: 'Molybdenum',
  boron: 'Boron',

  // other
  choline: 'Choline',
};

export const HELPER_TEXT = 'helper-text';
// Http Statuses
export enum HTTP_STATUS {
  SUCCESS = 200,
  CREATED = 201,
  SERVER_ERROR = 500,
  BAD_REQUEST = 400,
  NOT_FOUND = 404,
}

export enum CardTypes {
  VISA = 'visa',
  MASTERCARD = 'mastercard',
  AMEX = 'amex',
  UNIONPAY = 'unionpay',
  JCB = 'jcb',
  DINERS = 'diners',
  DISCOVER = 'discover',
}

export enum SettingsTabs {
  SUBSCRIPTION = 'subscription',
  INVOICES = 'invoices',
  CHANGE_PASSWORD = 'change-password',
  PROFILE = 'profile',
}

export enum StaffDetailTabs {
  EDIT_INFO = 'edit-info',
  SUBSCRIPTION = 'current-subscription',
  INVOICES = 'invoices',
}

export enum OrgStaffDetailTabs {
  DETAILS = 'details',
  SUBSCRIPTION = 'current-subscription',
}

export enum UserDetailTabs {
  EDIT_INFO = 'edit-info',
  SUBSCRIPTION = 'current-subscription',
  INVOICES = 'invoices',
  STAFF = 'staff',
}

// Invalid Messages
export const WRONG_EMAIL_OR_PASSWORD = 'You have entered wrong email or password';
export const INVALID_EMAIL = 'Invalid email address';
export const PASSWORD_VALIDATION_MESSAGE =
  'Password must contain 8 characters, one uppercase, one lowercase, one number and one special case character';

export const IS_STAGE = ENV.ENVIRONMENT === 'staging';
export const PAGE_LIMIT = 5;
export const drawerWidth = 280;
export const EMPTY_CELL = 'empty';
export const LOADING_TABLE_ROWS = 8;
export const MAX_IMAGE_SIZE = 3000000;
export const PAGINATION = [5, 10, 25];
export const EMPTY_OPTION = { value: '', name: '--' };
export const EMPTY_INGREDIENT_OPTION: IngredientItemFormType = IngredientsItemFormInitialValues;
export const SYMBOLS_ARRAY: Array<SymbolsType> = [
  { symbol: 'α', title: 'Alpha' },
  { symbol: 'β', title: 'Beta' },
  { symbol: 'γ', title: 'Gamma' },
  { symbol: 'δ', title: 'Delta' },
  { symbol: 'ε', title: 'Epsilon' },
  { symbol: 'η', title: 'Eta' },
  { symbol: 'θ', title: 'Theta' },
  { symbol: 'λ', title: 'Lambda' },
  { symbol: 'μ', title: 'Mu' },
  { symbol: 'π', title: 'Pi' },
  { symbol: 'σ', title: 'Sigma' },
  { symbol: 'τ', title: 'Tau' },
  { symbol: 'φ', title: 'Phi' },
  { symbol: 'χ', title: 'Chi' },
  { symbol: 'ψ', title: 'Psi' },
  { symbol: 'ω', title: 'Omega' },
];

// exports
export * from 'constants/constant';
export * from 'constants/tabs';
export * from 'constants/regex';
export * from 'constants/routes';
export * from 'constants/sideBarData';
export * from 'constants/tableHeaders';
export * from 'constants/countriesList';
export * from 'constants/states';
export * from 'constants/formInitialValues';
export * from 'constants/mappedData';
